import { Account as AccountDropdown } from '#~/routes/scaffold/header/account/account.js';
import { openVendorSupport } from '#~/routes/invite/components/invite-error-utils.js';
import { Anchor } from '@studio/design-system/button';
import { Logo } from '@studio/design-system/logo';
import { twMerge } from 'cn';

export const StudioNotFound = () => {
  return (
    <div className='h-screen overflow-y-auto px-16 py-24'>
      <div className='flex flex-col items-center'>
        <div className='self-end'>
          <AccountDropdown className='ml-auto' />
        </div>

        <Anchor
          onClick={(): void => {
            window.location.href = '/';
          }}
        >
          <Logo className='pb-40 pt-8' size='2x' />
        </Anchor>

        <div
          className={twMerge(
            'flex max-w-[450px] flex-col rounded-12 border-t-12 bg-light text-base-100',
            'border-t-error'
          )}
        >
          <div className={twMerge('m-32 my-48 flex grow flex-col items-center text-center')}>
            <i className='i-ion-warning-outline text-[80px] text-error' />
            <h1 className='mt-12'>Studio not found</h1>
            <p>
              This Studio is no longer shared, or has been deleted. Make sure you are signed in with
              the correct account, or contact the Studio owner or our{' '}
              <Anchor
                className='inline text-primary hover:text-primary-highlight'
                onClick={() => {
                  openVendorSupport();
                }}
              >
                support.
              </Anchor>
            </p>
            <a href='/' className='mt-32 text-primary underline hover:text-primary-highlight'>
              Return to my Studio
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
